import React from "react";
import { Link } from "react-router-dom";
import { Image, Button, Grid, Container, Divider } from "semantic-ui-react";
import brillTablet from "../../assets/images/brill-tablet.png";

import { SECTIONS } from "../../shared/constants";
import PageMenu from "./PageMenu";

const SECTIONMAP = {};
SECTIONS.map(sobj => (SECTIONMAP[sobj.key] = sobj));

const defaultHeaderExtras = [
  <Button style={{ marginTop: "2.75em" }}>
    <Link to={`${process.env.REACT_APP_URL_PATH}/lists/`}>Lists</Link>
  </Button>,
  <Button style={{ marginTop: "2.75em" }}>
    <Link to={`${process.env.REACT_APP_URL_PATH}/cerlpda/`}>CERL PDA</Link>
  </Button>
];

const DefaultPageHeader = ({
  section = null,
  extras = defaultHeaderExtras,
  history
}) => (
  <div>
    <Container className="header">
      <Grid>
        <Grid.Column width={12}>
          <div className="logo">
            <Link to={`${process.env.REACT_APP_URL_PATH}/`}>
              <Image
                src={brillTablet}
                className="brill-tablet"
                inline
                verticalAlign="top"
              />
              <span className="title">
                <h1>Natuurkundige Commissie Archives Online</h1>
                <h2>
                  Providing access to the hidden treasures of the ‘Natuurkundige Commissie’ (1820-1850)
                </h2>
              </span>
            </Link>
          </div>
        </Grid.Column>

        <Grid.Column width={4} className="page-menu">
          <PageMenu history={history} />
        </Grid.Column>
      </Grid>
    </Container>
    <Divider />
  </div>
);

export default DefaultPageHeader;
